/**
 * Theme Composable
 */

import { computed } from 'vue'
import { useUiStore } from '@/stores/ui.store'
import type { Theme } from '@/stores/ui.store'

export function useTheme() {
    const uiStore = useUiStore()

    const theme = computed(() => uiStore.theme)
    const isDark = computed(() => uiStore.theme === 'dark')
    const isLight = computed(() => uiStore.theme === 'light')

    function toggleTheme() {
        uiStore.toggleTheme()
    }

    function setTheme(newTheme: Theme) {
        uiStore.setTheme(newTheme)
    }

    function initializeTheme() {
        uiStore.initializeTheme()
    }

    return {
        theme,
        isDark,
        isLight,
        toggleTheme,
        setTheme,
        initializeTheme,
    }
}
